import api from './client';

export const applicationsAPI = {
  getAll: async () => {
    const response = await api.get('/applications');
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/applications/${id}`);
    return response.data;
  },

  create: async (collegeId) => {
    const response = await api.post('/applications', { college_id: collegeId });
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/applications/${id}`, data);
    return response.data;
  },

  submit: async (id) => {
    const response = await api.post(`/applications/${id}/submit`);
    return response.data;
  },
};

// Recommenders API
export const recommendersAPI = {
  getAll: async (appId) => {
    const response = await api.get(`/applications/${appId}/recommenders`);
    return response.data;
  },

  add: async (appId, recommender) => {
    const response = await api.post(`/applications/${appId}/recommenders`, recommender);
    return response.data;
  },

  submitRecommendation: async (recId, content) => {
    const response = await api.post(`/recommenders/${recId}/submit`, null, { params: { content } });
    return response.data;
  },
};

// Honors API
export const honorsAPI = {
  update: async (appId, honors) => {
    const response = await api.put(`/applications/${appId}/honors`, honors);
    return response.data;
  },
};

// Supplemental Essays API
export const supplementalAPI = {
  getPrompts: async (collegeId) => {
    const response = await api.get(`/colleges/${collegeId}/supplemental-prompts`);
    return response.data;
  },

  update: async (appId, essays) => {
    const response = await api.put(`/applications/${appId}/supplemental-essays`, essays);
    return response.data;
  },
};

// Additional Info API
export const additionalInfoAPI = {
  update: async (appId, info) => {
    const response = await api.put(`/applications/${appId}/additional-info`, null, { params: { additional_info: info } });
    return response.data;
  },
};

// Documents API
export const documentsAPI = {
  getAll: async (appId) => {
    const response = await api.get(`/applications/${appId}/documents`);
    return response.data;
  },

  upload: async (appId, file, documentType = 'Other') => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post(`/applications/${appId}/documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params: { document_type: documentType },
    });
    return response.data;
  },
};

// Courses API (SRAR)
export const coursesAPI = {
  update: async (appId, courses) => {
    const response = await api.put(`/applications/${appId}/courses`, courses);
    return response.data;
  },
};

// Application Versions API
export const applicationVersionsAPI = {
  copy: async (appId, newCollegeId) => {
    const response = await api.post(`/applications/${appId}/copy`, null, { params: { new_college_id: newCollegeId } });
    return response.data;
  },

  lock: async (appId) => {
    const response = await api.post(`/applications/${appId}/lock`);
    return response.data;
  },
};

// Review API
export const reviewAPI = {
  getReview: async (applicationId) => {
    const response = await api.get(`/review/application/${applicationId}`);
    return response.data;
  },

  getChecklist: async (applicationId) => {
    const response = await api.get(`/review/checklist/${applicationId}`);
    return response.data;
  },

  submit: async (applicationId, confirmAccuracy, confirmFerpa) => {
    const response = await api.post(`/review/application/${applicationId}/submit`, {
      confirm_accuracy: confirmAccuracy,
      confirm_ferpa: confirmFerpa,
    });
    return response.data;
  },
};

// Submission API
export const submissionAPI = {
  validate: async (applicationId) => {
    const response = await api.get(`/submission/validate/${applicationId}`);
    return response.data;
  },

  submit: async (applicationId, submissionData) => {
    const response = await api.post(`/submission/submit/${applicationId}`, submissionData);
    return response.data;
  },

  getStatus: async (applicationId) => {
    const response = await api.get(`/submission/status/${applicationId}`);
    return response.data;
  },

  getAll: async () => {
    const response = await api.get('/submission/all');
    return response.data;
  },

  getConfirmation: async (applicationId) => {
    const response = await api.get(`/submission/confirmation/${applicationId}`);
    return response.data;
  },

  withdraw: async (applicationId) => {
    const response = await api.post(`/submission/withdraw/${applicationId}`);
    return response.data;
  },
};

export default applicationsAPI;
